// @flow

import React from 'react';
import type { ResultItemContainerProps } from '../../../utils/types';
import { shape, string, array } from 'prop-types';

const DefaultItem = ({ result, translations }: ResultItemContainerProps) => {
  const {
    title,
    '@id': url,
    description,
    phd_state,
    phd_type,
    UID,
    year,
  } = result;
  return (
    <div className="course-item" key={UID}>
      <div className="course-infos">
        <div className="course-type">
          {phd_type.map((phd, i) => (
            <span key={`course-type-${i}`}>
              {phd.title} {i < phd_type.length - 1 ? ' - ' : ''}
            </span>
          ))}
        </div>
        <div className={'course-status ' + phd_state.token}>
          <span>{phd_state.title}</span>
        </div>
      </div>
      <div className="course-title">
        <a href={url} title={title}>
          <h2>{title.concat(year ? ` (${year})` : '')}</h2>
        </a>
      </div>
      {description && <div className="course-description">{description}</div>}
      <div className="course-footer">
        <a href={url} title={translations.search_readmore}>
          {translations.search_readmore || 'Read more'}
        </a>
      </div>
    </div>
  );
};

DefaultItem.propTypes = {
  result: shape({
    title: string,
    '@id': string,
    effective: string,
    description: string,
    UID: string,
    year: string,
    phd_state: shape({ token: string }),
    phd_type: array,
  }).isRequired,
  translations: shape({ search_phd_readmore: string }),
};

export default DefaultItem;
